import { OpenAPI } from "src/api"
import { environment } from "src/config"

OpenAPI.BASE = environment.API_BASE_URL
